import React from 'react';
import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import * as Routes from '@/modules/routes';
import { MediaMap } from '@/types/api/v2/MediaMapSchema';
import Modal from '@/components/common/Modal';
import IImage from '@/components/interfaces/Image';
import ImageInfoModalBody from './ImageInfoModalBody';

interface ImageInfoModalProps {
  closeModal: () => void;
  imageModelId: number;
  isOpen: boolean;
  programId: number;
}

const ImageInfoModal = ({ programId, closeModal, imageModelId, isOpen }: ImageInfoModalProps) => {
  const { data: image, isLoading: isLoadingImage } = useQuery(
    ['imageModelImage', imageModelId],
    () => axios
      .get<IImage>(Routes.plato_api_image_image_model_path(imageModelId))
      .then(response => response.data),
  );

  const { data: mediaMaps, isLoading: isLoadingMediaMaps } = useQuery(
    ['imageModelMediaMaps', imageModelId],
    () => axios
      .get<MediaMap[]>(Routes.plato_api_media_maps_image_model_path(imageModelId))
      .then(response => response.data),
  );

  const isLoading = isLoadingImage || isLoadingMediaMaps;

  return (
    <Modal
      closeable
      preventScroll
      shouldCloseOnOverlayClick
      bodyClassName="tw-h-[500px] tw-max-h-[550px] tw-min-h-[550px]"
      closeModal={closeModal}
      headerText="Image Details"
      isLoading={isLoading}
      isOpen={isOpen}
    >
      <ImageInfoModalBody
        image={image}
        mediaMaps={mediaMaps}
        programId={programId}
      />
    </Modal>
  );
};

export default ImageInfoModal;
